
import { Component, Vue, Prop} from 'vue-property-decorator';
import StepBase from "../StepBase.vue";
import YourInformation from "./YourInformation.vue";
import FilingLocation from "./FilingLocation.vue";
import OtherPartyCommon from "./otherPartyComponent/OtherPartyCommon.vue";
import SafetyCheck from "./SafetyCheck.vue";
import Notice from "./Notice.vue";
import { stepInfoType } from "@/types/Application";

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");


@Component({
    components:{
        StepBase,
        SafetyCheck,
        YourInformation,
        OtherPartyCommon,
        Notice,
        FilingLocation
    }
})
export default class CommonInformationStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
